import ScoreByDeviceBarChart from './ScoreByDeviceBarChart';
export default ScoreByDeviceBarChart;



// WEBPACK FOOTER //
// ./src/components/ScoreByDeviceBarChart/index.js